<template>
  <div id="framework-content">
    <!-- 当前位置 -->
    <div class="content-position">在线充值</div>
    <!-- 内容区域 -->
    <div class="content-main">

      <!-- 我的账户 -->
      <div class="my-count-box">
        <div class="my-count-bar">
          <label class="form-title">充值账户：</label>
          <span class="form-info" v-if="user.mobile">{{user.mobile}}</span>
          <span class="form-info" v-else>{{user.mail}}</span>
        </div>
        <div class="my-count-bar">
          <label class="form-title">账户余额：</label>
          <span class="form-info">{{balance}}元</span>
        </div>
        <div class="my-count-bar">
          <label class="form-title">充值金额：</label>
          <input type="text" @blur="checkMoney" v-model="accountBalance" placeholder="请输入充值金额">
          <span class="form-unit">元</span>
          <span class="form-tips">{{balanceTips}}</span>
        </div>
        <div class="my-count-bar">
          <label class="form-title">支付方式：</label>
          <div class="form-pay-way" v-for="(way, index) in payWay">
            <label @click="selectPayWay(index)"><b v-show="way.isSelected"></b></label>
            <img :src="'../../assets/images/personal/'+ way.name + '.png'" @click="selectPayWay(index)">
          </div>
        </div>
        <div class="my-count-bar">
          <button class="form-pay" @click="goPay">充&nbsp;&nbsp;值</button>
        </div>
      </div>

  		<!-- 是否支付成功弹窗 -->
  		<transition name="fade">
          <div class="pay-box" v-if="isPayStatus">
              <div class="bgshade-box"></div>
              <div class="con-box">
                  <h4>充值</h4>
                  <form action="" method="">
                      <p class="form-item money-pay pay-status">
                        <span @click="payLast">完成支付</span>
                      </p>
                      <p class="form-item money-pay pay-status">
                        <span @click="payLast">支付失败</span>
                      </p>
                      <p class="form-item customer-service">联系客服：010-84770602</p>
                  </form>
              </div>
          </div>
  		</transition>

    </div>
  </div>
</div>
</template>

<script>
	import Loading from '@/components/common/Loading';
  import Accounting from 'accounting';
	import CONST from '@/lib/const';

	export default {
		name: 'accountBalance',
    components:{Loading},
    mounted (){
      this.getAccountBalance();
    },
		data () {
			return {
				isPay:false,
				isPayStatus:false,
				balance: '',
        user: this.$getLocalStorage('IP360', 'user'),
        // payWay: [{
        //   name: 'alipay',
        //   isSelected: true
        // },{
        //   name: 'weChat',
        //   isSelected: false
        // }],
        payWay: [{
          name: 'alipay',
          isSelected: true
        }],
        accountBalance: '',
        valid: false,
        balanceTips:''
      }
		},
		methods: {
      checkMoney () {
        let reg = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
        this.valid = reg.test(this.accountBalance);
        this.balanceTips = this.valid ? '' : '请输入有效金额' ;

        return this.valid;
      },
      // 获取账户余额
      getAccountBalance(){
        this.$store.commit('showLoadingPersonal',true);
        this.$axios.request({
          url: '/webapi/personal/getTaskListByPage',
          method: 'get',
          params: {
            operatorId: this.user.id,
            pageNo: 1,
            pageSize: 10,
            searchType: 3,
            token: this.user.token,
            timestamp:new Date().getTime()
          }
        }).then((response) => {
          this.$store.commit('showLoadingPersonal',false);
          let result = response.data;
          if(result.code == 200){
            this.balance = Accounting.formatMoney(parseFloat(result.datas.balance/100).toFixed(2),'');
          }
        });
      },
      selectPayWay (index) {
        this.payWay.forEach( item => {
          item.isSelected = false
        })
        this.payWay[index].isSelected = true;
      },
			goPay () {
        this.checkMoney();
				if(this.valid){
					this.openPostWindow(GlobalConfig.webApiServer + '/webapi/webPay/alipayapi?',
            this.accountBalance,
            this.user.id,
            this.user.token,
            101
          );
					this.isPayStatus = true;
				}
			},
      openPostWindow (url, money,userId, token, type) {
        let newWin = window.open();
        let formStr = '';
        //设置样式为隐藏，打开新标签再跳转页面前，如果有可现实的表单选项，用户会看到表单内容数据
        formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '">' +
          '<input type="hidden" name="money" value="' + money + '" />' +
          '<input type="hidden" name="userId" value="' + userId + '" />' +
          '<input type="hidden" name="token" value="' + token + '" />' +
          '<input type="hidden" name="type" value="' + type + '" />' +
          '</form>';

        newWin.document.body.innerHTML = formStr;
        newWin.document.forms[0].submit();
      },
			payLast () {
        this.getAccountBalance();
        this.accountBalance = '';
        this.isPayStatus = false;
			}
		}
	}
</script>

<style scoped>
  .my-count-box{
    /*width: 390px;*/
    width: 280px;
    margin: 80px auto;
    font-size: 14px;
  }
  .my-count-bar{
    height: 48px;
    line-height: 48px;
    position: relative;
  }
	.my-count-bar label.form-title{
    float: left;
    width: 80px;
  }
  .my-count-bar span.form-info{
    float: left;
  }
  .my-count-bar input{
    float: left;
    width: 172px;
    height: 34px;
    border: 1px solid #ddd;
    margin-top: 7px;
    padding-left: 10px;
  }
  .my-count-bar .form-pay-way{
    float: left;
  }
  .my-count-bar .form-pay-way:nth-child(3){
    margin-left: 24px;
  }
  .my-count-bar .form-pay-way label{
    width: 16px;
    height: 16px;
    border: 1px solid #c45;
    border-radius: 50%;
    float: left;
    margin-top: 18px;
  }
  .my-count-bar .form-pay-way label b{
    width: 8px;
    height: 8px;
    display: block;
    margin: auto;
    background: #c45;
    border-radius: 50%;
    margin-top: 3px;
  }
  .my-count-bar .form-pay-way img{
    float: left;
    margin-top: 10px;
    cursor: pointer;
    margin-left: 12px;
  }
  .my-count-bar .form-pay{
    /*width: 306px;*/
    width: 172px;
    height: 34px;
    line-height: 34px;
    background: #d54d5d;
    color: #fff;
    border: 0;
    outline: 0;
    margin-left: 80px;
    cursor: pointer;
  }
  .my-count-bar span.form-unit{
    float: left;
    margin-left: 10px;
  }
  .my-count-bar .form-tips{
    position: absolute;
    width: 160px;
    left: 290px;
    color: #c45;
  }
  /*------------------------ popup style*/
  .pay-box{
    position: relative;
  }
  .pay-box,.bgshade-box{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .bgshade-box{
    background-color: rgba(0,0,0,0.5);
    font-size: 16px;
    filter: alpha(opacity=50);
  }
  .con-box{
    width:446px;
    background: #fff;
    border-radius: 5px;
    border:1px solid #Eb828c;
    padding: 16px 17px;
    box-sizing: border-box;
    position: absolute;
    left:50%;
    top:32%;
    margin-left: -223px;
  }
  .con-box h4{
    font-size: 16px;
    color: #a12935;
    height: 36px;
    line-height: 36px;
    font-weight: normal;
    position: relative;
  }
  .con-box p.form-item{
    width: 90%;
  }
  .con-box p.money-pay{
    height: 40px;
  }
  .con-box p.money-pay span{
    float: left;
    display: block;
    width: 92%;
    text-align: center;
    color: #fff;
    margin-left: 8%;
    background-color: #b71d2a;
    height: 40px;
    line-height: 40px;
    border-radius: 6px;
    margin-bottom: 20px;
    cursor:pointer;
  }
  .con-box p.pay-status{
    margin: 30px 0;
  }
  .con-box p.customer-service{
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #c1c1c1;
  }
	/*------------------------ animation style*/
	.fade-enter-active, .fade-leave-active {
	  	transition: opacity 0.5s;
	}
	.fade-enter, .fade-leave-active {
	  	transition: .2s;
	 	opacity: 0;
	}

</style>



// WEBPACK FOOTER //
// OnlinePayment.vue?0c639d92